import { useFacebookCookies } from './useFacebookCookies'

/**
 * Page view tracking deliberately lives outside resources/js/app.js. The
 * @inertiajs/vite plugin rewrites the entry module (to inject page resolution
 * and the SSR bootstrap) without emitting a sourcemap, which drops the entry
 * from the bundle's source map. Keeping this runtime code in an imported
 * module preserves accurate Bugsnag stack traces for the per-navigation logic.
 */
export function usePageViewTracking() {
    const { appendFacebookCookiesToLinks } = useFacebookCookies()

    let currentPageTitle = 'Top 5 Supplements'

    /**
     * Inertia writes document.title via a debounced DOM renderer, so it isn't
     * settled when the navigate event fires. The title resolver, however, runs
     * synchronously while the new page's <Head> commits during Vue's render, so
     * we capture the resolved title here and report it to GTM on navigation.
     */
    function resolvePageTitle(title) {
        currentPageTitle = title ? `${title} | Top 5 Supplements` : 'Top 5 Supplements'

        return currentPageTitle
    }

    function trackPageViews(router) {
        let initialPageLoad = true

        router.on('navigate', event => {
            /**
             * Decorate outbound links with the Facebook cookies on every page
             * visit, including pages rendered by client-side Inertia navigations.
             */
            appendFacebookCookiesToLinks()

            /**
             * Google Tag Manager only observes the initial full page load on its
             * own, so client-side Inertia navigations push a virtual page view
             * into the data layer. The initial load is skipped because the GTM
             * container snippet in the root template already records it.
             */
            if (initialPageLoad) {
                initialPageLoad = false

                return
            }

            setTimeout(() => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'virtualPageView',
                    pageUrl: event.detail.page.url,
                    pageLocation: window.location.href,
                    pageTitle: currentPageTitle,
                })
            })
        })
    }

    return {
        resolvePageTitle,
        trackPageViews,
    }
}
